/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  /**
   * Reinitialize reviews when filters are applied
   * This handles various review platforms including REVIEWS.io, Judge.me, and others
   */
  // Function to reinitialize reviews
  function reinitializeReviews() {
    // Wait a moment for the page content to settle
    setTimeout(function() {
      // Try to re-trigger reviews initialization for various platforms
      
      // For REVIEWS.io
      if (typeof REVIEWSIO !== 'undefined' && typeof REVIEWSIO.loadWidgets === 'function') {
        REVIEWSIO.loadWidgets();
      }
      
      // For Judge.me
      if (typeof jdgm !== 'undefined' && typeof jdgm.refreshWidgets === 'function') {
        jdgm.refreshWidgets();
      }
      
      // For Yotpo
      if (typeof yotpo !== 'undefined' && typeof yotpo.refreshWidgets === 'function') {
        yotpo.refreshWidgets();
      }
      
      // Generic approach - dispatch a custom event
      document.dispatchEvent(new CustomEvent('reviews:reload'));
      
      // Force review stars to display by showing their containers
      var reviewElements = document.querySelectorAll('.ruk_rating_snippet');
      reviewElements.forEach(function(element) {
        element.style.display = 'block';
      });
    }, 500);
  }

  /**
   * Fixes the filter counts for variant options (like sizes) when the "In Stock" filter is active
   * This ensures size options that have no available variants don't show positive counts
   */
  function fixVariantFilterCounts() {
    console.log('Running fixVariantFilterCounts');
    
    // Check if we're on a collection page with the In Stock filter applied
    if (!window.location.pathname.includes('/collections/') || 
        !window.location.search.includes('filter.v.availability=1')) {
      console.log('Not a collection page with availability filter');
      return;
    }

    console.log('Collection page with availability filter detected');

    // PART 1: Handle filter options
    // Get all filter groups and check if we have size filters
    const filterGroups = document.querySelectorAll('.sidebar__filter__group');
    console.log(`Found ${filterGroups.length} filter groups`);
    
    filterGroups.forEach(group => {
      // Skip non-variant option filters
      const groupType = group.getAttribute('data-filter-group');
      if (!groupType || !groupType.includes('option.')) {
        return;
      }

      console.log(`Processing filter group: ${groupType}`);
      
      // Get product grid items (which should only include in-stock products)
      // Try multiple selectors to ensure we find products
      let productItems = document.querySelectorAll('product-grid-item');
      if (productItems.length === 0) {
        productItems = document.querySelectorAll('.product-grid-item');
      }
      if (productItems.length === 0) {
        productItems = document.querySelectorAll('.js-grid > div');
      }
      
      console.log(`Found ${productItems.length} product items`);
      if (!productItems.length) return;

      // For each filter option in the filter group
      const filterOptions = group.querySelectorAll('.filter__button');
      console.log(`Found ${filterOptions.length} filter options in group ${groupType}`);
      
      filterOptions.forEach(option => {
        const checkbox = option.querySelector('input[type="checkbox"]');
        if (!checkbox) return;
        
        // Skip already selected options
        if (checkbox.checked) return;
        
        // Get the option value from the input
        const optionValue = checkbox.value;
        if (!optionValue) return;
        
        // Get the filter name from the checkbox name
        const filterNameMatch = checkbox.name.match(/filter\.v\.option\.([^=]+)/);
        if (!filterNameMatch) return;
        const filterName = filterNameMatch[1];
        
        console.log(`Processing filter option: ${filterName} = ${optionValue}`);
        
        // The label showing the count
        const countLabel = option.querySelector('label');
        if (!countLabel) return;
        
        // Extract current count from the label
        const countMatch = countLabel.textContent.match(/\((\d+)\)/);
        if (!countMatch) return;
        
        let availableCount = 0;
        
        // Count only products where this specific variant option is available
        productItems.forEach(product => {
          // Try to get variant availability data from data attributes
          const variantData = product.querySelector('[data-variant-json]');
          if (!variantData) {
            console.log('No variant data found for product');
            return;
          }
          
          try {
            const variants = JSON.parse(variantData.getAttribute('data-variant-json'));
            if (!variants || !Array.isArray(variants)) return;
            
            // Find which option index corresponds to our filter (size, color, etc.)
            let optionIndex = -1;
            if (variants.length > 0 && variants[0].options) {
              // Common mappings for option positions
              if (filterName.toLowerCase().includes('size')) {
                optionIndex = 0;  // Size is often first option
              } else if (filterName.toLowerCase().includes('color') || 
                        filterName.toLowerCase().includes('colour')) {
                optionIndex = 1;  // Color is often second option
              }
              
              // Look at the first variant to determine option positions if we still don't know
              if (optionIndex === -1) {
                for (let i = 0; i < variants[0].options.length; i++) {
                  // Try to guess from option values
                  const optValues = variants.map(v => v.options[i]).filter(Boolean);
                  const isColorOption = optValues.some(v => 
                    ['black', 'white', 'blue', 'red', 'green', 'yellow'].includes(v.toLowerCase()));
                  const isSizeOption = optValues.some(v => 
                    /^(xs|s|m|l|xl|xxl|\d+(\.\d+)?(uk)?)$/i.test(v.replace(/\s+/g, '')));
                  
                  if ((filterName.toLowerCase().includes('size') && isSizeOption) ||
                      ((filterName.toLowerCase().includes('color') || filterName.toLowerCase().includes('colour')) && isColorOption)) {
                    optionIndex = i;
                    break;
                  }
                }
              }
              
              // If we still couldn't determine, just try all options
              if (optionIndex === -1) {
                for (let i = 0; i < variants[0].options.length; i++) {
                  const hasMatchingVariant = variants.some(variant => {
                    return variant.available && 
                           variant.options[i] && 
                           variant.options[i].toLowerCase() === decodeURIComponent(optionValue).toLowerCase();
                  });
                  
                  if (hasMatchingVariant) {
                    optionIndex = i;
                    break;
                  }
                }
              }
            }
            
            // Default to option 0 if we still can't determine
            if (optionIndex === -1) optionIndex = 0;
            
            // Check if any available variant has this option
            const hasAvailableVariantWithOption = variants.some(variant => {
              // Check if variant is available
              if (!variant.available) return false;
              
              // Get the option value at the determined index
              const variantOptionValue = variant.options[optionIndex];
              if (!variantOptionValue) return false;
              
              // Compare the variant option with the filter value (case insensitive)
              return variantOptionValue.toLowerCase() === decodeURIComponent(optionValue).toLowerCase();
            });
            
            if (hasAvailableVariantWithOption) {
              availableCount++;
            }
          } catch (e) {
            console.error('Error parsing variant data:', e);
          }
        });
        
        console.log(`Filter ${filterName}=${optionValue} has ${availableCount} available items`);
        
        // If no products have this option available in stock, disable it
        if (availableCount === 0) {
          console.log(`Disabling option ${optionValue} for ${filterName}`);
          checkbox.disabled = true;
          option.classList.add('filter__button--disabled');
          countLabel.classList.add('sold-out');
        }
      });
    });
    
    // PART 2: Hide products that don't have the selected size variant available
    const urlParams = new URLSearchParams(window.location.search);
    const sizeParams = Array.from(urlParams.entries())
      .filter(([key]) => key.includes('filter.v.option.size') || key.includes('filter.v.option.Size'));
    
    console.log(`Found ${sizeParams.length} size filter parameters`);
    
    // If we have a size filter active
    if (sizeParams.length > 0) {
      const selectedSizes = sizeParams.map(([_, value]) => decodeURIComponent(value).toLowerCase());
      console.log(`Selected sizes: ${selectedSizes.join(', ')}`);
      
      // Now check all products to hide those without the selected size in stock
      // Try multiple selectors to find products
      let productItems = document.querySelectorAll('product-grid-item');
      if (productItems.length === 0) {
        productItems = document.querySelectorAll('.product-grid-item');
      }
      if (productItems.length === 0) {
        productItems = document.querySelectorAll('.js-grid > div');
      }
      
      console.log(`Found ${productItems.length} product items to check for size availability`);
      
      productItems.forEach((product, index) => {
        const variantData = product.querySelector('[data-variant-json]');
        if (!variantData) {
          console.log(`Product ${index} - no variant data found`);
          return;
        }
        
        try {
          const variants = JSON.parse(variantData.getAttribute('data-variant-json'));
          if (!variants || !Array.isArray(variants)) return;
          
          // Find which option index corresponds to size
          let sizeOptionIndex = -1;
          
          // Size is almost always the first option (index 0)
          sizeOptionIndex = 0;
          
          // Check if any variant with the selected size is available
          const hasSizeInStock = variants.some(variant => {
            if (!variant.available) return false;
            
            const variantSize = (variant.options[sizeOptionIndex] || '').toLowerCase();
            return selectedSizes.includes(variantSize);
          });
          
          console.log(`Product ${index} - has selected size in stock: ${hasSizeInStock}`);
          
          // Hide product if the selected size is not available
          if (!hasSizeInStock) {
            // Find the grid item container - try several common selectors
            let gridItem = null;
            const possibleContainers = [
              product.closest('.js-grid > div'),
              product.closest('[data-product-grid-item]'),
              product.closest('.grid__item'),
              product.closest('.product-grid-item'),
              product
            ];
            
            for (const container of possibleContainers) {
              if (container) {
                gridItem = container;
                break;
              }
            }
            
            if (gridItem) {
              console.log(`Hiding product ${index} - selected size not available`);
              gridItem.style.display = 'none';
            } else {
              console.log(`Couldn't find container to hide for product ${index}`);
            }
          }
        } catch (e) {
          console.error(`Error checking product ${index} size availability:`, e);
        }
      });
    }
    
    console.log('fixVariantFilterCounts completed');
  }

  // Run on various events
  function initFilters() {
    // If we're on a collection page with filters applied
    if (window.location.pathname.includes('/collections/') && window.location.search.includes('filter')) {
      console.log('Collection page with filters - initializing');
      reinitializeReviews();
      // Run immediately and also with a delay
      fixVariantFilterCounts();
      setTimeout(fixVariantFilterCounts, 800);
    }
    
    // Set up event listeners
    document.addEventListener('collection:updated', function() {
      console.log('Collection updated event');
      reinitializeReviews();
      fixVariantFilterCounts();
      setTimeout(fixVariantFilterCounts, 500);
    });
    
    document.addEventListener('shopify:section:load', function(event) {
      console.log('Section load event');
      if (event.target.classList.contains('collection-template')) {
        reinitializeReviews();
        fixVariantFilterCounts();
        setTimeout(fixVariantFilterCounts, 500);
      }
    });

    document.addEventListener('ajaxComplete', function(event) {
      if (window.location.pathname.includes('/collections/')) {
        console.log('AJAX complete event on collection page');
        reinitializeReviews();
        fixVariantFilterCounts();
        setTimeout(fixVariantFilterCounts, 500);
      }
    });

    // Add a mutation observer to detect when products are added to the page
    const targetNode = document.querySelector('.collection-template') || document.querySelector('.collection__content');
    if (targetNode) {
      console.log('Setting up mutation observer');
      const observer = new MutationObserver(function(mutations) {
        let shouldUpdate = false;
        for (const mutation of mutations) {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            shouldUpdate = true;
            break;
          }
        }
        
        if (shouldUpdate) {
          console.log('DOM mutation detected - updating filters');
          reinitializeReviews();
          fixVariantFilterCounts();
          setTimeout(fixVariantFilterCounts, 500);
        }
      });
      
      observer.observe(targetNode, { childList: true, subtree: true });
    }

    // Check if In Stock filter should be auto-applied on page load
    if (window.location.pathname.includes('/collections/')) {
      if (!window.location.search.includes('filter')) {
        const filterForm = document.querySelector('[data-sidebar-filter-form]');
        if (filterForm) {
          const inStockCheckbox = filterForm.querySelector('input[name="filter.v.availability"][value="1"]');
          if (inStockCheckbox && !inStockCheckbox.checked) {
            console.log('Auto-applying in-stock filter');
            inStockCheckbox.checked = true;
            
            // Trigger form submission to apply the filter
            const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
            filterForm.dispatchEvent(submitEvent);
          }
        }
      } else if (window.location.search.includes('filter.v.availability=1')) {
        console.log('In stock filter already applied');
        // Process multiple times with increasing delays
        fixVariantFilterCounts();
        setTimeout(fixVariantFilterCounts, 500);
        setTimeout(fixVariantFilterCounts, 1500);
      }
    }
  }

  // Run on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function() {
    console.log('DOMContentLoaded - initializing filters');
    initFilters();
  });

  // Also run on window load with multiple attempts
  window.addEventListener('load', function() {
    console.log('Window loaded - running filter fixes');
    if (window.location.pathname.includes('/collections/')) {
      // Run multiple times with different delays to ensure it works
      fixVariantFilterCounts();
      setTimeout(fixVariantFilterCounts, 500);
      setTimeout(fixVariantFilterCounts, 1500);
      setTimeout(fixVariantFilterCounts, 3000);
    }
  });

  // Add a special fallback for really slow pages
  setTimeout(function() {
    if (window.location.pathname.includes('/collections/')) {
      console.log('Final fallback execution');
      fixVariantFilterCounts();
    }
  }, 4000);

})();
